import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '提供信息',
  '您需要提供有关您当前医疗状况以及任何传染性疾病的准确且完整的信息，包括过去的疾病、住院经历、药物、预先医疗指示（AMD）以及其他相关细节，以便您获得适当且安全的医疗护理。',
  '如果您有任何现存的传染性疾病，请及时告知我们，以便采取适当的感染控制措施。您的长期健康取决于您认识到生活方式对个人健康的影响并承担责任。',
  '请告知我们您的健康状况的任何变化。',
  '在获取您医生的报告副本时，请确保在离开之前已收到正确信息。',
];

const contents2 = [
  '尊重与体谅',
  '我们请求您与您的家属体谅也需要休息以及工作人员照顾的病患；请尊重他人的权利，并对所有工作人员、医生、护士及访客表现出尊重和礼貌。',
  '您需对自己在住院期间的行为举止负责；任何威胁、骚扰或有意伤害他人或扰乱医院运作的行为都是不可接受的。',
  '请遵守为患者安全而制定的医院规定（例如探视政策）。',
  '请尊重医院的设备和设施，合理使用这些财产，并注意帮助我们减少宝贵资源的浪费，例如资源使用等。',
];

const contents3 = [
  '入院须知',
  '请勿携带任何贵重物品，因为您需对个人财物的安全负责。',
  '请按指定时间到医院报到入院手续，以确保必要的术前准备能够在安全且可控的环境下完成。',
  '您将在治疗过程中由医生告知相关的财务责任，包括手术费用和住院费用。',
  '您有责任支付账单或做出适当安排以履行您的财务义务。按时支付账单将有助于医院继续专注于为其他患者提供服务。',
];

const contents4 = [
  '药物与治疗',
  '您在住院期间的所有药物将由本院药房提供，并由工作人员负责管理和使用。',
  '请勿擅自操作任何医疗设备。',
  '除非需向医生展示，请勿携带非住院中使用的药物。您应携带一份书面的药物清单，并将此清单提供给医生和病房的护士查看。您从家中带来的任何药物将不会被使用，并会归还给您自行保管。',
];

const PatientsResponsibility = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="患者的责任" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents2.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents3.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents4.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default PatientsResponsibility;
